// import router from './router'
// import { useAppStoreWithOut } from '@/store/modules/app'
// import type { RouteRecordRaw } from 'vue-router'
// import { useTitle } from '@/hooks/web/useTitle'
// import { useNProgress } from '@/hooks/web/useNProgress'
// import { usePermissionStoreWithOut } from '@/store/modules/permission'
// import { usePageLoading } from '@/hooks/web/usePageLoading'
// import { NO_REDIRECT_WHITE_LIST } from '@/constants'
// import { useUserStoreWithOut } from '@/store/modules/user'

// const { start, done } = useNProgress()

// const { loadStart, loadDone } = usePageLoading()

// router.beforeEach(async (to, from, next) => {
//   start()
//   loadStart()
//   const permissionStore = usePermissionStoreWithOut()
//   const userStore = useUserStoreWithOut()
//   // 同时检查 token 和 userInfo，确保用户已正确登录
//   const hasToken = userStore.getToken && userStore.getToken !== ''
//   const hasUserInfo = userStore.getUserInfo
  
//   if (hasToken && hasUserInfo) {
//     if (to.path === '/login') {
//       next({ path: '/' })
//     } else {
//       if (permissionStore.getIsAddRouters) {
//         next()
//         return
//       }
//       await permissionStore.generateRoutes();
//       userStore.setRoleRouters(permissionStore.addRouters);
//       userStore.getRoleRouters.forEach((route) => {
//         router.addRoute(route as RouteRecordRaw)
//       })
//       const redirectPath = from.query.redirect || to.path
//       const redirect = decodeURIComponent(redirectPath as string)
//       const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect }
//       permissionStore.setIsAddRouters(true)
//       next(nextData)
//     }
//   } else {
//     // 如果没有登录信息，清除可能存在的残留状态
//     if (hasUserInfo || hasToken) {
//       userStore.setToken('')
//       userStore.setUserInfo(undefined)
//       permissionStore.setIsAddRouters(false)
//     }
//     if (NO_REDIRECT_WHITE_LIST.indexOf(to.path) !== -1) {
//       next()
//     } else {
//       next(`/login?redirect=${to.path}`)
//     }
//   }
// })

// router.afterEach((to) => {
//   useTitle(to?.meta?.title as string)
//   done() // 结束Progress
//   loadDone()
// })
import router from './router'
import { useAppStoreWithOut } from '@/store/modules/app'
import type { RouteRecordRaw } from 'vue-router'
import { useTitle } from '@/hooks/web/useTitle'
import { useNProgress } from '@/hooks/web/useNProgress'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { usePageLoading } from '@/hooks/web/usePageLoading'
import { NO_REDIRECT_WHITE_LIST } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'

const { start, done } = useNProgress()

const { loadStart, loadDone } = usePageLoading()

router.beforeEach(async (to, from, next) => {
  start()
  loadStart()
  const permissionStore = usePermissionStoreWithOut()
  const userStore = useUserStoreWithOut()
  // console.log(userStore.getUserInfo);
  if (userStore.getUserInfo) {
    if (to.path === '/login') {
      const roles = userStore.getUserInfo?.roles || []
      const redirectPath = roles.includes('customer') ? '/goods/wholesale' : '/'
      next({ path: redirectPath })
    } else {
      if (to.path === '/' && userStore.getUserInfo.roles?.includes('customer')) {
        next({ path: '/goods/wholesale' })
        return
      }
      if (permissionStore.getIsAddRouters) {
        next()
        return
      }
      //  console.log(1111111111);
      // next()
      // 开发者可根据实际情况进行修改
      // permissionStore.getAddRouters.forEach((route) => {
      //   router.addRoute(route as unknown as RouteRecordRaw) // 动态添加可访问路由表
      // })
      const roles = userStore.getUserInfo?.roles || []
      await permissionStore.generateRoutes(roles);
      userStore.setRoleRouters(permissionStore.addRouters);
      userStore.getRoleRouters.forEach((route) => {
        router.addRoute(route as RouteRecordRaw) // 动态添加可访问路由表
      })
      const redirectPath = from.query.redirect || to.path
      const redirect = decodeURIComponent(redirectPath as string)
      const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect }
      permissionStore.setIsAddRouters(true)
      next(nextData)
    }
  } else {
    if (NO_REDIRECT_WHITE_LIST.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
    }
  }
})

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  done() // 结束Progress
  loadDone()
})
